module.exports = __webpack_public_path__ + "static/media/caret-square-right.35fe5f73.svg";